/* Catalogue-wide frame/mount previews; purchase configuration stays on products. */
(() => {
  document.querySelectorAll('[data-ak-catalog-controls]').forEach(root => {
  if (root.classList.contains('ak-mobile-carousel-controls') && !matchMedia('(max-width:1200px)').matches) return;
  const data = document.querySelector('[data-ak-catalog-config]');
  if (!root || !data || root.dataset.akCatalogBound) return;
  root.dataset.akCatalogBound = 'true';
  const options = JSON.parse(data.textContent);
  const posterGeometry = window.AK_POSTER_GEOMETRY;
  const storageKey = 'ak-catalog-preview-v1';
  const groups = ['frame', 'mount'];
  const pickers = Object.fromEntries(groups.map(group => [group, root.querySelector(`[data-ak-catalog-picker="${group}"]`)]));
  const find = (group, value) => options[group].find(option => option.value === value);
  let current = {frame: 'black_wood', mount: 'none', chosen: {frame: false, mount: false}};
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey));
    groups.forEach(group => {
      if (find(group, saved?.[group])) current[group] = saved[group];
      current.chosen[group] = saved?.chosen?.[group] === true;
    });
  } catch (_) { /* Session storage is optional. */ }
  current = window.AK_PAPER_PREFS?.read() || current;
  if (!current.chosen?.mount) current.mount='none';
  let requested = {...current};
  let revision = 0;
  let openGroup = null;
  let previewing = false;
  const images = new Map();
  const sourceRatios = new WeakMap();
  const status = root.querySelector('[data-ak-catalog-status]');
  const carousel = root.closest('.ak-featured-carousel');
  const globalCarousel = root.hasAttribute('data-ak-catalog-global');
  const stages = () => [...(globalCarousel ? document : carousel || document).querySelectorAll(carousel ? `${globalCarousel ? '#MainContent ' : ''}[data-ak-carousel-poster]:not([data-ak-cart-preview])` : '#filterable .ak-collection-framed-art')];

  function preload(url) {
    if (!url) return Promise.resolve();
    if (!images.has(url)) {
      const promise = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => img.decode ? img.decode().then(resolve, resolve) : resolve();
        img.onerror = () => reject(new Error('Preview image could not load'));
        img.src = url;
      });
      images.set(url, promise);
      promise.catch(() => images.delete(url));
    }
    return images.get(url);
  }

  function closeMenus(focus = false) {
    restorePreview();
    const previous = openGroup;
    groups.forEach(group => {
      const menu=pickers[group].querySelector('.ak-catalog-menu');
      menu.hidden=true;
      menu.parentElement.classList.contains('ak-catalog-menu-viewport') && (menu.parentElement.hidden=true);
      menu.getAnimations().forEach(animation=>animation.cancel());
      pickers[group].querySelector('button').setAttribute('aria-expanded', 'false');
    });
    openGroup = null;
    if (focus && previous) pickers[previous].querySelector('button').focus({preventScroll: true});
  }
  function sizeOpenMenu() {
    if (!openGroup) return;
    const picker=pickers[openGroup],trigger=picker.querySelector('button'),menu=picker.querySelector('.ak-catalog-menu');
    const edge=document.querySelector('.ak-bottom-nav')?.getBoundingClientRect().top ?? innerHeight-60;
    menu.style.maxHeight=`${Math.max(88,Math.min(innerHeight,edge)-trigger.getBoundingClientRect().bottom-1)}px`;
  }
  ['ak:papers-mobile-landed','ak:browser-resume','ak:layout-refresh'].forEach(name=>window.addEventListener(name,sizeOpenMenu));
  function openMenu(group, focus = false) {
    if (openGroup === group) { closeMenus(focus); return; }
    closeMenus();
    const picker = pickers[group];
    const trigger = picker.querySelector('button');
    const menu = picker.querySelector('.ak-catalog-menu');
    const bottomEdge = document.querySelector('.ak-bottom-nav')?.getBoundingClientRect().top ?? innerHeight - 60;
    menu.style.maxHeight = `${Math.max(88, Math.min(innerHeight, bottomEdge) - trigger.getBoundingClientRect().bottom - 1)}px`;
    trigger.setAttribute('aria-expanded', 'true');
    const viewport=menu.parentElement;
    if(viewport.classList.contains('ak-catalog-menu-viewport'))viewport.hidden=false;
    menu.hidden = false;
    if(matchMedia('(max-width:1200px)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
      menu.animate([{transform:'translateY(-100%)'},{transform:'translateY(0)'}],{duration:360,easing:'cubic-bezier(.22,1,.36,1)'});
    }
    openGroup = group;
    requestAnimationFrame(sizeOpenMenu);
    const selected = menu.querySelector('[aria-checked="true"]');
    if (selected) {
      menu.scrollTop = Math.max(0, selected.offsetTop - menu.clientHeight / 2);
      if (focus) selected.focus({preventScroll: true});
    }
  }
  function syncMenus() {
    groups.forEach(group => {
      const selected = find(group, current[group]);
      const picker = pickers[group];
      const trigger = picker.querySelector('button');
      trigger.style.setProperty('--ak-catalog-selected-color', selected.color);
      trigger.dataset.akColorChosen = String(current[group] !== 'none');
      trigger.dataset.akCatalogSelection = current[group];
      trigger.setAttribute('aria-label', `Select ${group}: ${selected.label}`);
      trigger.title = selected.label;
      picker.querySelectorAll('[data-ak-catalog-value]').forEach(button => {
        const checked = button.dataset.akCatalogValue === current[group];
        button.setAttribute('aria-checked', String(checked));
        button.dataset.akCommitted = String(checked && current.chosen[group]);
        button.tabIndex = checked ? 0 : -1;
      });
    });
  }

  // CSS percentages follow the existing artwork registration, without
  // alternating layout reads/writes for every product when an option changes.
  function aluBorder(stage, format, hasMount, scale) {
    let border = stage.querySelector('.ak-css-alu-frame');
    if (!border) {
      border = document.createElement('span');
      border.className = 'ak-css-alu-frame';
      border.setAttribute('aria-hidden', 'true');
      stage.append(border);
    }
    let left, top, width, height, artOffset = 0;
    if (hasMount) {
      const canvas = posterGeometry.formats[format].canvas;
      const bounds = format === 'portrait' ? [432,234,1428,1626]
        : format === 'landscape' ? [234,432,1626,1428] : [432,431,1429,1428];
      left = canvas[0] + canvas[2] * bounds[0] / 1860;
      top = canvas[1] + canvas[3] * bounds[1] / 1860;
      width = canvas[2] * (bounds[2] - bounds[0]) / 1860;
      height = canvas[3] * (bounds[3] - bounds[1]) / 1860;
    } else {
      const read = name => parseFloat(stage.style.getPropertyValue(`--ak-card-art-${name}`)) || 0;
      const [t,r,b,l] = stage.style.getPropertyValue('--ak-card-art-trim').trim().split(/\s+/).map(value => parseFloat(value) / 100);
      left = 50 + read('left') + read('width') * scale * (l - .5);
      top = 50 + read('top') + read('height') * scale * (t - .5);
      width = read('width') * scale * (1 - l - r);
      height = read('height') * scale * (1 - t - b);
      artOffset = .5;
    }
    const aspect = Number(stage.style.getPropertyValue('--ak-card-aspect'));
    const {thickness, outside} = window.akAluFrameMetrics(width, height / aspect);
    // cqw follows the stage width; vertical percentages follow stage height.
    stage.style.containerType = 'inline-size';
    Object.assign(border.style, {
      left: `calc(${left - outside}% + ${artOffset}px)`, top: `${top - outside * aspect}%`,
      width: `${width + outside * 2}%`, height: `${height + outside * 2 * aspect}%`,
      borderWidth: '0px'
    });
    border.style.setProperty('--ak-alu-x', `${thickness}cqw`);
    border.style.setProperty('--ak-alu-y', `${thickness}cqw`);
    border.hidden = false;
  }
  function renderAll(selection) {
    const frame = find('frame', selection.frame);
    const mount = find('mount', selection.mount);
    const hasMount = selection.frame !== 'none' && selection.mount !== 'none';
    const cards = stages();
    cards.forEach(stage => {
      const format = stage.dataset.format;
      if (stage.hasAttribute('data-ak-carousel-poster')) {
        stage.dispatchEvent(new CustomEvent('ak:catalog-poster-selection', {detail:selection}));
        return;
      }
      const frameImage = stage.querySelector('.ak-collection-frame');
      const mountImage = stage.querySelector('.ak-collection-mount');
      const art = stage.querySelector('.ak-collection-art');
      const geometry = posterGeometry.formats[format];
      const aspect = Number(stage.style.getPropertyValue('--ak-card-aspect'));
      if (!sourceRatios.has(stage)) {
        sourceRatios.set(stage, parseFloat(stage.style.getPropertyValue('--ak-card-art-width')) /
          parseFloat(stage.style.getPropertyValue('--ak-card-art-height')) * aspect);
      }
      const fit = posterGeometry.fitSource(100, 100/aspect, sourceRatios.get(stage), geometry.trim);
      stage.style.setProperty('--ak-card-art-width', `${fit.sourceWidth}%`);
      stage.style.setProperty('--ak-card-art-height', `${fit.sourceHeight * aspect}%`);
      stage.style.setProperty('--ak-card-art-left', `${fit.screenOffsetX}%`);
      stage.style.setProperty('--ak-card-art-top', `${fit.screenOffsetY * aspect}%`);
      stage.style.setProperty('--ak-card-art-trim', geometry.trim.map(value => `${value * 100}%`).join(' '));
      const scale = posterGeometry.artScale(format, selection.frame, hasMount) * geometry.cropScale;
      const offset = posterGeometry.artOffset(format, selection.frame, hasMount);
      art.style.left = `calc(50% + var(--ak-card-art-left) + ${offset.x}px)`;
      art.style.top = `calc(50% + var(--ak-card-art-top) + ${offset.y}px)`;
      [frameImage,mountImage].forEach(image => {
        ['left','top','width','height'].forEach((name,index) => image.style[name] = `${geometry.canvas[index]}%`);
      });
      stage.style.setProperty('--ak-card-art-scale', scale);
      stage.dataset.akPreviewFrame = selection.frame;
      stage.dataset.akPreviewMount = selection.mount;
      frameImage.hidden = !frame.assets[format];
      mountImage.hidden = !hasMount;
      if (frame.assets[format] && frameImage.getAttribute('src') !== frame.assets[format]) frameImage.src = frame.assets[format];
      if (hasMount && mountImage.getAttribute('src') !== mount.assets[format]) mountImage.src = mount.assets[format];
      const border = stage.querySelector('.ak-css-alu-frame');
      if (selection.frame === 'black_alu') aluBorder(stage, format, hasMount, Number(scale));
      else if (border) border.hidden = true;
    });
    return cards.length;
  }
  function restorePreview() {
    if (!previewing) return;
    previewing = false;
    ++revision;
    renderAll(current);
    root.removeAttribute('aria-busy');
    status.textContent = 'Selected catalogue preview restored';
  }
  async function apply(selection, save = true, preview = false) {
    previewing = preview;
    const token = ++revision;
    root.setAttribute('aria-busy', 'true');
    status.textContent = 'Updating catalogue previews';
    try {
      const formats = [...new Set(stages().map(stage => stage.dataset.format))];
      const urls = formats.flatMap(format => [find('frame', selection.frame).assets[format],
        selection.frame !== 'none' && selection.mount !== 'none' ? find('mount', selection.mount).assets[format] : null]);
      await Promise.all([...new Set(urls.filter(Boolean))].map(preload));
      if (token !== revision) return;
      await new Promise(resolve => requestAnimationFrame(resolve));
      if (token !== revision) return;
      const count = renderAll(selection);
      if (preview) {
        status.textContent = `Previewing ${find('frame', selection.frame).label} frame and ${find('mount', selection.mount).label} mount. Click to select.`;
        return;
      }
      current = {...selection};
      syncMenus();
      if (save) { try { sessionStorage.setItem(storageKey, JSON.stringify(current)); } catch (_) {} window.AK_PAPER_PREFS?.write(current, root); }
      const finish = current.frame === 'none' ? 'No frame' : `${find('frame', current.frame).label} frame${current.mount === 'none' ? ' without mount' : ` with ${find('mount', current.mount).label} mount`}`;
      status.textContent = `${finish} applied to ${count} artworks`;
    } catch (_) {
      if (token === revision) {
        if (!preview) requested = {...current};
        status.textContent = 'The preview could not load. Please choose again.';
      }
    } finally {
      if (token === revision) root.removeAttribute('aria-busy');
    }
  }

  groups.forEach(group => {
    const picker = pickers[group];
    const trigger = picker.querySelector('button');
    const menu = picker.querySelector('.ak-catalog-menu');
    const viewport=document.createElement('div');
    viewport.className='ak-catalog-menu-viewport';viewport.hidden=true;
    menu.before(viewport);viewport.append(menu);
    options[group].forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ak-catalog-option';
      button.dataset.akCatalogValue = option.value;
      button.setAttribute('role', 'menuitemradio');
      const swatch = document.createElement('span'); swatch.className = 'ak-catalog-swatch'; swatch.style.backgroundColor = option.color; swatch.setAttribute('aria-hidden','true');
      if (option.value === 'none') swatch.classList.add('ak-catalog-swatch-none');
      const label = document.createElement('span'); label.textContent = option.label;
      button.append(swatch, label);
      const previewOption = () => {
        if (openGroup !== group) return;
        const selection = {...requested, [group]: option.value};
        if (group === 'mount' && option.value !== 'none' && selection.frame === 'none') selection.frame = 'black_wood';
        apply(selection, false, true);
      };
      button.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') previewOption();
      });
      button.addEventListener('focus', previewOption);
      button.addEventListener('click', () => {
        requested = {...requested, [group]: option.value, chosen: {...requested.chosen, [group]: true}};
        if (group === 'mount' && option.value !== 'none' && requested.frame === 'none') requested.frame = 'black_wood';
        closeMenus(true);
        apply({...requested});
      });
      menu.append(button);
    });
    menu.addEventListener('pointerleave', restorePreview);
    trigger.addEventListener('click', () => openMenu(group));
    trigger.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (openGroup !== group) openMenu(group, true);
        else menu.querySelector('[aria-checked="true"]').focus({preventScroll: true});
      }
    });
    menu.addEventListener('keydown', event => {
      const buttons = [...menu.querySelectorAll('button')];
      const index = buttons.indexOf(document.activeElement);
      let next;
      if (event.key === 'ArrowDown') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) {
        event.preventDefault();
        buttons[next].focus({preventScroll: true});
        const item = buttons[next];
        if (item.offsetTop < menu.scrollTop) menu.scrollTop = item.offsetTop;
        if (item.offsetTop + item.offsetHeight > menu.scrollTop + menu.clientHeight) menu.scrollTop = item.offsetTop + item.offsetHeight - menu.clientHeight;
      }
    });
  });
  root.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); closeMenus(true); } });
  root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) closeMenus(); });
  document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) closeMenus(); }, {passive:true});
  addEventListener('resize', () => closeMenus(), {passive:true});
  const results = carousel || document.querySelector('#results');
  if (results) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches('.ak-collection-framed-art') || node.querySelector('.ak-collection-framed-art'))))) renderAll(current);
  }).observe(results, {childList:true, subtree:true});
  document.addEventListener('ak:collection-page-changed', () => apply({...current}, false));
  window.addEventListener('ak:paper-finish-change',event=>{
    if(event.detail.source===root || !event.detail.selection)return;
    requested={...event.detail.selection};
    closeMenus();
    apply({...requested},false);
  });
  syncMenus();
  apply({...current}, false);
  });
})();
